import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtilComponentModule } from '../../../components/util/util-component.module';
import { FileSettingsComponent } from './file-settings/file-settings.component';
import { StoryBoardNoteItemComponent } from './file-settings/story-board-note-item/story-board-note-item.component';

@NgModule({
  imports: [FormsModule, CommonModule, UtilComponentModule],
  declarations: [FileSettingsComponent, StoryBoardNoteItemComponent],
  exports: [FileSettingsComponent],
})
export class FileAttributeModule {
  // -- // -- //
}
